module OhoOfficePicker {
  let stateSelect: JQuery<HTMLElement>;
  let citySelect: JQuery<HTMLElement>;
  let officesSelect: JQuery<HTMLElement>;

  export function construct() {
    stateSelect = $("#OhoOfficeStateSelect");
    citySelect = $("#OhoOfficeCitySelect");
    officesSelect = $("#OhoOfficesSelect");

    stateSelect.change(stateSelectChanged);
    citySelect.change(citySelectChanged);

    if (stateSelect.length > 0) {
      stateSelectChanged();
    }
  }

  function stateSelectChanged() {
    clearOfficeCitySelect();
    clearOfficeSelect();
    SelectTools.addBlankOption(citySelect);

    const state = selectedState();
    OhoOfficeFactory.GetCitiesByState(state,
      (cities: string[]) => {
        $.each(cities, (index, city) => {
          citySelect.append(`<option>${city}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of cities with Oho Offices for the state ${state}.`);
      }
    );
  }

  function citySelectChanged() {
    clearOfficeSelect();
    SelectTools.addBlankOption(officesSelect);

    const state = selectedState();
    const city = selectedCity();
    OhoOfficeFactory.GetOhoOfficesByStateCity(state, city,
      (ohoOffices) => {
        $.each(ohoOffices, (index, ohoOffice) => {
          officesSelect.append(`<option value="${ohoOffice.RowID}">${ohoOffice.Address}</option>`);
        });
      },
      () => {
        Notifications.Warning(`Failed to retrieve list of Oho Offices for ${city}, ${state}.`);
      }
    );
  }

  const selectedState = () => stateSelect.val() as States;
  const selectedCity = () => citySelect.val() as string;

  const clearOfficeCitySelect = () => citySelect.html("");
  const clearOfficeSelect = () => officesSelect.html("");
}